<template>
  <div class="contactPhoneEmailAddress" v-if="contact">
    <!--Phones-->
    <ul class="no-bullet phones-list" v-if="contact.phones.length > 0">
      <li v-for="phone in contact.phones" :key="phone.id" class="hover-parent" :class="{ 'hover-show-touch': activePhoneId === phone.id }">
        <div :class="{ 'active-action-button-row': activePhoneId === phone.id }">
          <div class="grid-x">
            <div class="cell auto">
              <!--Value-->
              <span :class="{ 'text-strike': phone.is_bad }" @click="toggleActiveRecord('phone', phone)">
                <a :href="'tel:' + phone.number" class="no-color fs-block">{{ phone.number }}</a>
              </span>
              <!--Hover Call Button-->
              <span class="hover-child" v-if="activePhoneId !== phone.id">
                &nbsp;
                <a class="button small success"
                   @click="dialContact(phone)"
                   v-if="readyToDial && !phone.is_bad">
                  <span class="fas fa-phone"></span> Dial
                </a>
              </span>
            </div>
            <div class="cell shrink">
              <!--Hover Actions Button-->
              <span class="hover-child" v-if="activePhoneId !== phone.id">
                <a
                  class="button small hollow secondary"
                  @click="toggleActiveRecord('phone', phone)">
                  <span class="fas fa-ellipsis-h"></span>
                </a>
              </span>
              <!--Icons-->
              <span class="record-flag-icons">
                <small v-if="phone.is_enrichment">
                  <span class="fas fa-magic text-muted" v-tooltip.top-center="'Auto-Enrichment'"></span>
                </small>
                <small v-if="phone.is_integration" v-tooltip.top-center="'ActBlue Integration'">
                  <span class="fas fa-link text-muted"></span>
                </small>
                <!--Icons (only show primary or verified to save screen space)-->
                <small v-if="phone.is_primary" v-tooltip.top-center="'Primary' + (phone.is_verified ? ' and Verified' : '')">
                  <span class="fas fa-star text-muted"></span>
                </small>
                <small v-else-if="phone.is_verified" v-tooltip.top-center="'Verified'">
                  <span class="fas fa-check text-muted"></span>
                </small>
              </span>
              <!--Record Type-->
              <span class="record-type-label">
                {{ phone.type }}
              </span>
            </div>
          </div>
          <!--Action Buttons-->
          <div class="action-button-row">
            <template v-if="phone.is_bad">
              <!--Undo Bad-->
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Undo bad number'"
                 @click="markPhoneBad(phone, true)">
                <span class="fas fa-thumbs-up"></span>
              </a>
            </template>
            <template v-else>
              <!--Call-->
              <a class="button small success"
                 @click="dialContact(phone)"
                 v-if="readyToDial">
                <span class="fas fa-phone"></span> Dial
              </a>
              <!--Mark Bad-->
              <a class="button small hollow secondary"
                 @click="markPhoneBad(phone)"
                 v-tooltip.top-center="'Mark as bad number'">
                <span class="fas fa-thumbs-down"></span>
              </a>
              <!--Valid/Invalid-->
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Mark verified'"
                 @click="markPhoneVerified(phone)"
                 v-if="!phone.is_verified">
                <span class="fas fa-check"></span>
              </a>
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Mark as NOT verified'"
                 @click="markPhoneVerified(phone, true)"
                 v-else>
                <span class="fas fa-check text-danger"></span>
              </a>
              <!--Set Primary-->
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Set as primary'"
                 @click.stop="markPhonePrimary(phone)"
                 v-if="!phone.is_primary">
                <span class="far fa-star"></span>
              </a>
            </template>
            <a class="button small hollow secondary"
               v-tooltip.top-center="'Remove primary status'"
               @click.stop="markPhonePrimary(phone, true)"
               v-if="phone.is_primary">
              <span class="fas fa-star text-danger"></span>
            </a>
            <span class="float-right">
              <a class="button small hollow secondary" @click="clearActiveRecord()">
                <span class="fas fa-times"></span>
              </a>
            </span>
          </div>
        </div>
      </li>
    </ul>

    <!--Emails-->
    <ul class="no-bullet emails-list" v-if="contact.emails.length > 0">
      <li v-for="email in contact.emails" :key="email.id" class="hover-parent" :class="{ 'hover-show-touch': activeEmailId === email.id }">
        <div :class="{ 'active-action-button-row': activeEmailId === email.id }">
          <div class="grid-x">
            <div class="cell auto">
              <!--Value-->
              <span :class="{ 'text-strike': email.is_bad }" @click="toggleActiveRecord('email', email)">
                <a :href="'mailto:' + email.email" class="no-color fs-block">{{ email.email }}</a>
              </span>
            </div>
            <div class="cell shrink">
              <!--Hover Actions Button-->
              <span class="hover-child" v-if="activeEmailId !== email.id">
                <a
                  class="button small hollow secondary"
                  @click="toggleActiveRecord('email', email)">
                  <span class="fas fa-ellipsis-h"></span>
                </a>
              </span>
              <!--Icons-->
              <span class="record-flag-icons">
                <small v-if="email.is_enrichment">
                  <span class="fas fa-magic text-muted" v-tooltip.top-center="'Auto-Enrichment'"></span>
                </small>
                <small v-if="email.is_integration" v-tooltip.top-center="'ActBlue Integration'">
                  <span class="fas fa-link text-muted"></span>
                </small>
                <!--Icons (only show primary or verified to save screen space)-->
                <small v-if="email.is_primary" v-tooltip.top-center="'Primary' + (email.is_verified ? ' and Verified' : '')">
                  <span class="fas fa-star text-muted"></span>
                </small>
                <small v-else-if="email.is_verified" v-tooltip.top-center="'Verified'">
                  <span class="fas fa-check text-muted"></span>
                </small>
              </span>
              <!--Record Type-->
              <span class="record-type-label">
                {{ email.type }}
              </span>
            </div>
          </div>
          <!--Action Buttons-->
          <div class="action-button-row">
            <template v-if="email.is_bad">
              <!--Undo Bad-->
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Undo bad email'"
                 @click="markEmailBad(email, true)">
                <span class="fas fa-thumbs-up"></span>
              </a>
            </template>
            <template v-else>
              <!--Mark Bad-->
              <a class="button small hollow secondary"
                 @click="markEmailBad(email)"
                 v-tooltip.top-center="'Mark as bad email'">
                <span class="fas fa-thumbs-down"></span>
              </a>
              <!--Valid/Invalid-->
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Mark verified'"
                 @click="markEmailVerified(email)"
                 v-if="!email.is_verified">
                <span class="fas fa-check"></span>
              </a>
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Mark as NOT verified'"
                 @click="markEmailVerified(email, true)"
                 v-else>
                <span class="fas fa-check text-danger"></span>
              </a>
              <!--Set Primary-->
              <a class="button small hollow secondary"
                 v-tooltip.top-center="'Set as primary'"
                 @click.stop="markEmailPrimary(email)"
                 v-if="!email.is_primary">
                <span class="far fa-star"></span>
              </a>
            </template>
            <a class="button small hollow secondary"
               v-tooltip.top-center="'Remove primary status'"
               @click.stop="markEmailPrimary(email, true)"
               v-if="email.is_primary">
              <span class="fas fa-star text-danger"></span>
            </a>
            <span class="float-right">
              <a class="button small hollow secondary" @click="clearActiveRecord()">
                <span class="fas fa-times"></span>
              </a>
            </span>
          </div>
        </div>
      </li>
    </ul>

    <!--Addresses-->
    <ul class="list-padded addresses-list" v-if="contact.addresses.length > 0">
      <li v-for="address in contact.addresses" :key="address.id" class="hover-parent" :class="{ 'hover-show-touch': activeAddressId === address.id }">
        <div :class="{ 'active-action-button-row': activeAddressId === address.id }">
          <div class="grid-x">
            <div class="cell auto">
              <!--Address Value-->
              <div v-if="address.line_1">
                {{ address.line_1 }}
              </div>
              <div v-if="address.line_2">
                {{ address.line_2 }}
              </div>
              <div v-if="address.city || address.state || address.zip_code">
                {{ address.city }}<template v-if="address.city && address.state">, </template>
                {{ address.state }} {{ address.zip_code }}
              </div>
              <div v-if="address.country">
                {{ address.country }}
              </div>
            </div>
            <div class="cell shrink">
              <!--Hover Actions Button-->
              <span class="hover-child" v-if="activeAddressId !== address.id">
                <a
                  class="button small hollow secondary"
                  @click="toggleActiveRecord('address', address)">
                  <span class="fas fa-ellipsis-h"></span>
                </a>
              </span>
              <!--Icons-->
              <span class="record-flag-icons">
                <small v-if="address.is_enrichment">
                  <span class="fas fa-magic text-muted" v-tooltip.top-center="'Auto-Enrichment'"></span>
                </small>
                <small v-if="address.is_integration" v-tooltip.top-center="'ActBlue Integration'">
                  <span class="fas fa-link text-muted"></span>
                </small>
                <!--Icons (only show primary or verified to save screen space)-->
                <small v-if="address.is_primary" v-tooltip.top-center="'Primary' + (address.is_verified ? ' and Verified' : '')">
                  <span class="fas fa-star text-muted"></span>
                </small>
                <small v-else-if="address.is_verified" v-tooltip.top-center="'Verified'">
                  <span class="fas fa-check text-muted"></span>
                </small>
              </span>
              <!--Record Type-->
              <span class="record-type-label">
                {{ address.type }}
              </span>
            </div>
          </div>
          <!--Action Buttons-->
          <div class="action-button-row">
            <!--Valid/Invalid-->
            <a class="button small hollow secondary"
               v-tooltip.top-center="'Mark verified'"
               @click="markAddressVerified(address)"
               v-if="!address.is_verified">
              <span class="fas fa-check"></span>
            </a>
            <a class="button small hollow secondary"
               v-tooltip.top-center="'Mark as NOT verified'"
               @click="markAddressVerified(address, true)"
               v-else>
              <span class="fas fa-check text-danger"></span>
            </a>
            <!--Set Primary-->
            <a class="button small hollow secondary"
               v-tooltip.top-center="'Set as primary'"
               @click.stop="markAddressPrimary(address)"
               v-if="!address.is_primary">
              <span class="far fa-star"></span>
            </a>
            <a class="button small hollow secondary"
               v-tooltip.top-center="'Remove primary status'"
               @click.stop="markAddressPrimary(address, true)"
               v-if="address.is_primary">
              <span class="fas fa-star text-danger"></span>
            </a>
            <span class="float-right">
                <a class="button small hollow secondary" @click="clearActiveRecord()">
                  <span class="fas fa-times"></span>
                </a>
              </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ContactsService from '../../../services/ContactsService'
import { DialerBus } from '../../../dialer'

export default {
  props: {
    contact: Object
  },
  data () {
    return {
      activeRecordType: null,
      activeRecordId: null
    }
  },
  computed: {
    activePhoneId () {
      return this.activeRecordType === 'phone' ? this.activeRecordId : null
    },
    activeEmailId () {
      return this.activeRecordType === 'email' ? this.activeRecordId : null
    },
    activeAddressId () {
      return this.activeRecordType === 'address' ? this.activeRecordId : null
    },
    readyToDial () {
      // is the power dialer connected and ready to dial?
      return DialerBus.isActive && !DialerBus.isOnCall
    }
  },
  methods: {
    toggleActiveRecord (recordType, record) {
      if (!record || this.activeRecordId === record.id) {
        this.activeRecordType = null
        this.activeRecordId = null
      } else {
        this.activeRecordType = recordType
        this.activeRecordId = record.id
      }
    },
    clearActiveRecord () {
      this.toggleActiveRecord(null, null)
    },
    async markPhoneBad (phone, undoBad) {
      await ContactsService.updateBadContactPhone(phone.id, !undoBad)
    },
    async markPhoneVerified (phone, makeInvalid) {
      await ContactsService.updateVerifiedContactPhone(phone.id, !makeInvalid)
    },
    async markPhonePrimary (phone, removePrimary) {
      await ContactsService.updatePrimaryContactPhone(this.contact.id, phone.id, !removePrimary)
    },
    async markEmailBad (email, undoBad) {
      await ContactsService.updateBadContactEmail(email.id, !undoBad)
    },
    async markEmailVerified (email, makeInvalid) {
      await ContactsService.updateVerifiedContactEmail(email.id, !makeInvalid)
    },
    async markEmailPrimary (email, removePrimary) {
      await ContactsService.updatePrimaryContactEmail(this.contact.id, email.id, !removePrimary)
    },
    async markAddressVerified (address, makeInvalid) {
      await ContactsService.updateVerifiedContactAddress(address.id, !makeInvalid)
    },
    async markAddressPrimary (address, removePrimary) {
      await ContactsService.updatePrimaryContactAddress(this.contact.id, address.id, !removePrimary)
    },
    dialContact (phone) {
      DialerBus.dialContact(this.contact, phone.id)
    }
  }
}
</script>

<style lang="scss">
@import "../../../style/settings";

.contactPhoneEmailAddress {
  .action-button-row {
    display: none;
  }

  .active-action-button-row {
    border: 1px solid $border-color;
    border-radius: $card-border-radius;
    padding: 0.4em;
    margin-bottom: 0.5em;

    .action-button-row {
      display: block;
      margin-top: 0.4em;

      a {
        margin-right: 0.5em;
      }
    }
  }

  .record-flag-icons {
    small {
      margin-left: 0.5em;
    }
  }

  .record-type-label {
    color: $muted-font-color;
  }
}
</style>
